























































































import { Component, Vue, Watch } from "vue-property-decorator";
import { IAction } from "../common/CommonTypes";
import MoreVertBtn from "../common/MoreVertBtn.vue";
import { Dictionary } from "lodash";
import { RpasApi, CustomersApi, LocationsApi, UnitsApi } from "../../../apis";
import moment from "moment";
import { DataOptions, DataTableHeader } from "vuetify";
import VueI18n from "vue-i18n";
import ConfirmDialog from "../common/ConfirmDialog.vue";
import { AxiosResponse } from "axios";

export enum ACTION {
  VIEW = "VIEW",
  EDIT = "EDIT",
  DELETE = "DELETE",
  COPY = "COPY",
}

@Component({
  components: { MoreVertBtn, ConfirmDialog },
})
export default class RPAManagement extends Vue {
  get screenContext() {
    return "RPA_MANAGEMENT";
  }

  selectedRPA = {} as any;
  dataLicense = [];
  showLicenseKey = false;
  pagingOption: DataOptions | null = null;
  totalRecord: number = 0;

  confirmContent: string | VueI18n.TranslateResult = "";
  showConfirmDialog = false;

  allOption = { value: "", text: this.$t("text.all") };

  searchParam = {
    unitId: "",
    customerId: "",
    locationId: "",
    keyword: "",
  };

  customerOptions = [];
  unitOptions = [this.allOption];
  locationOptions = [this.allOption];

  selectedAction: ACTION;

  readonly EDIT_ACTION: IAction = {
    titleName: "Edit",
    action: ACTION.EDIT,
    permission: { context: this.screenContext, action: "update" },
  };

  readonly DELETE_ACTION: IAction = {
    titleName: "Delete",
    action: ACTION.DELETE,
    titleStyle: "color: red",
    permission: { context: this.screenContext, action: "delete" },
  };

  readonly VIEW_ACTION: IAction = {
    titleName: "View",
    action: ACTION.VIEW,
    permission: { context: this.screenContext, action: "read" },
  };

  readonly COPY_ACTION: IAction = {
    titleName: "Copy",
    action: ACTION.COPY,
    permission: { context: this.screenContext, action: "create" },
  };

  get actions(): Array<IAction> {
    return [this.VIEW_ACTION, this.EDIT_ACTION, this.COPY_ACTION, this.DELETE_ACTION];
  }

  get HEADERS() {
    return [
      {
        text: this.$t("text.customer"),
        value: "customer.companyName",
        class: ["tw-p-4"],
      },
      {
        text: this.$t("text.location"),
        value: "location.locationName",
        class: ["tw-p-4"],
      },
      {
        text: this.$t("text.unit"),
        value: "unit.name",
        class: ["tw-p-4"],
      },
      {
        text: this.$t("text.rpaName"),
        value: "rpaName",
        class: ["tw-p-4"],
      },
      {
        text: this.$t("text.action"),
        value: "action",
        class: ["tw-p-4"],
        sortable: false,
        width: 100,
      },
    ];
  }

  get ROW_PER_PAGES() {
    return this.$util.getConfig().settings.rowPerPage;
  }

  async mounted() {
    const res = await this.getActiveCustomer();
    this.customerOptions = res.data.data.map((customer) => ({
      text: customer.companyName,
      value: customer.id,
    }));
    this.customerOptions.unshift(this.allOption);
  }

  async getActiveCustomer(): Promise<AxiosResponse> {
    return await new CustomersApi().getAllCustomerByStringAndStatus({
      keyword: "",
      status: "Active",
    });
  }

  async onChangeCustomer() {
    this.locationOptions = [this.allOption];
    this.unitOptions = [this.allOption];
    if (!this.searchParam.customerId) return;
    try {
      this.$util.showLoading();
      const res = await new LocationsApi().getLocationsWithCustomer({
        customerId: this.searchParam.customerId,
      });
      this.locationOptions = res.data.data.map((location) => ({
        text: location.locationName,
        value: location.id,
      }));
      this.locationOptions.unshift(this.allOption);
    } catch (error) {
      this.$util.showError(error);
    } finally {
      this.$util.hideLoading();
    }
  }

  async onChangeLocation() {
    this.unitOptions = [this.allOption];
    if (!this.searchParam.locationId) return;
    try {
      this.$util.showLoading();
      const res = await new UnitsApi().getUnitByLocationId({
        locationId: this.searchParam.locationId,
      });
      this.unitOptions = res.data.data.map((unit) => ({
        text: unit.name,
        value: unit.id,
      }));
      this.unitOptions.unshift(this.allOption);
    } catch (error) {
      this.$util.showError(error);
    } finally {
      this.$util.hideLoading();
    }
  }

  onPagingOption() {
    this.doSearch();
  }

  async doSearch() {
    try {
      this.$util.showLoading();
      const res = await new RpasApi().getRpas({
        keyword: this.searchParam.keyword || "",
        unit: this.searchParam.unitId || "",
        customer: this.searchParam.customerId || "",
        location: this.searchParam.locationId || "",
        limit: this.pagingOption.itemsPerPage,
        page: this.pagingOption.page,
        orderBy: this.pagingOption.sortBy[0]
          ? this.pagingOption.sortBy[0]
          : "createdAt",
        orderDesc: this.pagingOption.sortDesc[0]
          ? this.pagingOption.sortDesc[0].toString()
          : "",
      });
      this.dataLicense = res.data.data;
      this.totalRecord = res.data.count;
    } catch (error) {
      this.$util.showError(error);
    } finally {
      this.$util.hideLoading();
    }
  }

  async onSelectedAction(item, action) {
    this.selectedRPA = { ...item };
    this.selectedAction = action;
    switch (action) {
      case ACTION.VIEW: {
        this.$router.push({
          name: "detail-rpa",
          params: { id: this.selectedRPA.id },
        });
        break;
      }
      case ACTION.EDIT: {
        this.$router.push({
          name: "edit-rpa",
          params: { id: this.selectedRPA.id },
        });
        break;
      }
      case ACTION.COPY: {
        this.$router.push({
          name: "add-rpa",
          query: { copyID: this.selectedRPA.id }
        });
        break;
      }
      case ACTION.DELETE: {
        this.showConfirmDialog = true;
        this.confirmContent = this.$t("dialog.delete.rpa");
        break;
      }
      default: {
        break;
      }
    }
  }

  onOkConfirmDialog() {
    if (this.selectedAction === ACTION.DELETE) {
      this.doDelete();
    }
  }

  async doDelete() {
    try {
      this.$util.showLoading();
      await new RpasApi().deleteRPA({
        id: this.selectedRPA.id,
      });
    } catch (error) {
      this.$util.showError(error);
    } finally {
      this.doSearch();
      this.$util.hideLoading();
    }
  }
}
